/**
 * @readonly
 * @enum {string}
 */
const { SINGLE_COURSE_SESSION } = require('./pricingOptionType');

module.exports = {
    // paying for lecture (reservation)
    LECTURE: 'lecture',
    // paying for course
    COURSE: 'course',
    // paying for single course session
    SINGLE_COURSE_SESSION,
    // paying for passes
    PASS: 'pass',
    // paying for credits
    CREDIT: 'credit',
    // workshop
    WORKSHOP: 'workshop',
    VOUCHER: 'voucher',
};
